<div class="taxonomy-shell container py-4" *ngIf="content as c">
  <!-- Breadcrumbs -->
  <nav class="taxonomy-breadcrumbs" aria-label="Breadcrumb" *ngIf="c.breadcrumbs?.length">
    <ol>
      <li *ngFor="let crumb of c.breadcrumbs; let last = last">
        <a *ngIf="crumb.route && !last" [routerLink]="crumb.route">{{ crumb.label }}</a>
        <span *ngIf="!crumb.route || last" aria-current="page">{{ crumb.label }}</span>
      </li>
    </ol>
  </nav>

  <!-- Heading + intro -->
  <header class="taxonomy-header">
    <h1 class="taxonomy-title">{{ c.heading }}</h1>
    <p class="taxonomy-intro" *ngFor="let para of c.intro">{{ para }}</p>
  </header>

  <!-- Internal links -->
  <section class="taxonomy-links" *ngIf="c.links?.length">
    <h2 class="taxonomy-links-title" *ngIf="c.linksHeading">{{ c.linksHeading }}</h2>
    <ul class="taxonomy-link-grid">
      <li *ngFor="let link of c.links">
        <a [routerLink]="link.route" class="taxonomy-link-card">
          <span class="taxonomy-link-label">{{ link.label }}</span>
          <span class="taxonomy-link-desc" *ngIf="link.description">{{ link.description }}</span>
        </a>
      </li>
    </ul>
  </section>

  <!-- Listing placeholder (real plate data wired in a later phase) -->
  <section class="taxonomy-listing" aria-label="Plate listings">
    <div class="taxonomy-listing-placeholder">
      {{ c.listingPlaceholder || 'Plate listings are coming soon.' }}
    </div>
  </section>

  <!-- CTAs -->
  <section class="taxonomy-ctas">
    <a *ngIf="c.showViewerCta" [routerLink]="'/plate-viewer'" class="taxonomy-cta taxonomy-cta-primary">
      See any plate on a car
    </a>
    <!-- "Value my plate" removed until valuations are live (4 Nov 2026). -->
  </section>
</div>
